<template>
  <div class="reportTable">
    <!-- <div style="display:flex">
      <div class="header-item" @click="change('show1')">
        <div>
          <img v-if="show1==true" src="../../assets/image/checked4.png" />
          <img v-else src="../../assets/image/check2.png" />
        </div>
        <span>显示押金/结账款明细</span>
      </div>

      <div class="header-item" @click="change('show2')">
        <div>
          <img v-if="show2==true" src="../../assets/image/checked4.png" />
          <img v-else src="../../assets/image/check2.png" />
        </div>
        <span>显示收回收据证明</span>
      </div>
      <div class="header-item" @click="change('show3')">
        <div>
          <img v-if="show3==true" src="../../assets/image/checked4.png" />
          <img v-else src="../../assets/image/check2.png" />
        </div>
        <span>显示冲账</span>
      </div>
      <div class="header-item" @click="change('show4')">
        <div>
          <img v-if="show4==true" src="../../assets/image/checked4.png" />
          <img v-else src="../../assets/image/check2.png" />
        </div>
        <span>显示补账</span>
      </div>
    </div> -->
    <div class="report">
      <section ref="print">
        <div :class="['report']" style="width: 100%; height: 100%">
          <div class="mytitle">
            <ul>
              <li>
                <span>打印日期：</span>
                <span>{{ nowday }}</span>
              </li>
              <li>
                <span>打印时间：</span>
                <span>{{ nowtime }}</span>
              </li>
              <li>
                <span>酒店日期：</span>
                <span>{{ $parent.hotelInfo.dhoteltime }}</span>
              </li>
            </ul>
            <ul
              style="display: flex; flex-direction: column; align-items: center"
            >
              <li>
                <span></span>
                <span>{{ $parent.hotelInfo.cname }}</span>
              </li>
              <li>
                <span></span>
                <span>{{ $parent.bbmc }}</span>
              </li>
              <li>
                <span>查询日期：</span>
                <span>
                  {{
                    this.$moment(this.startDates).format("YYYY-MM-DD")
                  }}
                </span>
                <span v-if="$parent.endTimeShow">
                  至{{
                    this.$moment(this.endDates).format("YYYY-MM-DD")
                  }}
                </span>
              </li>
            </ul>
            <ul
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-end;
              "
            >
              <li>
                <span>操作员:</span>
                <span>{{ $parent.userInfo.cname }}</span>
              </li>
              <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
              </li>-->
              <li v-if="$parent.datacount > 0">
                <span>总条数:</span>
                <span>{{ $parent.datacount }}条</span>
              </li>
            </ul>
          </div>
          <div class="reportMsg">
            <div class="reportLeft">
              <span>班次:</span>
              <span>{{ bcmc }}</span>
              <span>收银员:</span>
              <span>{{ czymc }}</span>
            </div>
            <div class="reprotRight">
              <span>审核人:</span>
              <div></div>
            </div>
          </div>
          <table
            style="border-collapse: collapse; text-align: right"
            align="center"
            width="100%"
          >
            <thead>
              <tr class="bdTop">
                <td colspan="13"></td>
              </tr>
              <tr class="thTr" style="border: 1px solid #000">
                <th style="text-align: left">账项（中文）</th>
                <th>1.定金</th>
                <th>数量</th>
                <th>
                  <div>2.1.结款</div>
                  <div>收款</div>
                </th>
                <th>数量</th>
                <th>
                  <div>2.2.结账</div>
                  <div>退款</div>
                </th>
                <th>数量</th>
                <th>
                  <div>2.结账款小计</div>
                  <div>2 = 2.1 + 2.2</div>
                </th>
                <th>数量</th>
                <th>
                  <div>3.缴款小计</div>
                  <div>3 = 1 + 2</div>
                </th>
                <th>4.收回数据</th>
                <th>数量</th>
                <th>
                  <div>5.营业收入</div>
                  <div>5 = 2 + 4</div>
                </th>
              </tr>
              <tr class="bdBottom">
                <td colspan="13"></td>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr style="height: 2px">
                  <td colspan="13"></td>
                </tr>
                <tr
                  style="border-right: 1px solid #000"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <td style="text-align: left">{{ item.chnname }}</td>
                  <td style="text-align: right">
                    {{ item.dingjin.toFixed(2) }}
                  </td>
                  <td>{{ item.dingjinnum }}</td>
                  <td style="text-align: right">
                    {{ item.shoukuan.toFixed(2) }}
                  </td>
                  <td>{{ item.shoukuannum }}</td>
                  <td style="text-align: right">
                    {{ item.tuikuan.toFixed(2) }}
                  </td>
                  <td>{{ item.tuikuannum }}</td>
                  <td style="text-align: right">{{ item.two }}</td>
                  <td>{{ item.num }}</td>
                  <td style="text-align: right">{{ item.three }}</td>
                  <td style="text-align: right">
                    {{ item.shouhuishouju.toFixed(2) }}
                  </td>
                  <td>{{ item.shouhuishoujunum }}</td>
                  <td style="text-align: right">{{ item.five }}</td>
                </tr>
              </template>
              <tr
                style="
                  border-top: 1px solid #000;
                  border-bottom: 1px solid #000;
                "
                v-if="list.length > 0"
              >
                <td>总计</td>
                <td>{{ curreny(obj.dingjin) }}</td>
                <td>{{ obj.dingjinnum }}</td>
                <td>{{ curreny(obj.shoukuan) }}</td>
                <td>{{ obj.shoukuannum }}</td>
                <td>{{ curreny(obj.tuikuan) }}</td>
                <td>{{ obj.tuikuannum }}</td>
                <td>{{ curreny(obj.two) }}</td>
                <td>{{ obj.num }}</td>
                <td>{{ curreny(obj.three) }}</td>
                <td>{{ curreny(obj.shouhuishouju) }}</td>
                <td>{{ obj.shouhuishoujunum }}</td>
                <td>{{ curreny(obj.five) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <div
        class="report"
        v-if="
          show1 &&
            parseFloat(payItemList.yaJin.length) +
              parseFloat(payItemList.jieZhang.length) >
              0
        "
      >
        <div style="margin-bottom: 5px;display:flex;align-items:center">
          押金、结账款明细
          <download-excel
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            :header="json_dataHead"
            :name="json_dataHead + '.xls'"
          >
            <div class="datadaochu" @click="daochu1">导出</div>
          </download-excel>
        </div>
        <div
          class="report-line"
          style="line-height: 30px;  border-top: 1px solid black"
        >
          <div>账号</div>
          <div>姓名</div>
          <div>房号</div>
          <div>收款方式</div>
          <div style="flex: 2">发生时间</div>
          <div style="text-align: right">金额</div>
          <div>酒店时间</div>
          <div>班次</div>
          <div>操作员</div>
          <div style="flex: 2">备注</div>
        </div>

        <div v-for="(item, index) in payItemDetail" :key="'a' + index">
          <div v-for="(item2, index2) in item.list" :key="item.accNo + index2">
            <div class="report-line">
              <div>{{ item2.accNo }}</div>
              <div>{{ item2.guestName }}</div>
              <div>{{ item2.roomNo }}</div>
              <div>{{ item2.chnName }}</div>
              <div style="flex: 2">{{ item2.createTime }}</div>
              <div style="text-align: right">{{ curreny(item2.amount) }}</div>
              <div>{{ item2.hotelTime }}</div>
              <div>{{ item2.shift }}</div>
              <div>{{ item2.Operator }}</div>
              <div style="flex: 2">{{ item2.remark }}</div>
            </div>
          </div>
          <div class="report-line" style="font-weight: bold">
            <div></div>
            <div></div>
            <div></div>
            <div style="text-align: center">{{ item.chnName }}</div>
            <div style="text-align: center; flex: 2">
              小计{{ item.list.length }}笔
            </div>
            <div style="text-align: right">{{ curreny(item.total) }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div style="flex: 2"></div>
          </div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">押金合计</div>
          <div style="text-align: center; flex: 2">
            小计{{ payItemList.yaJin.length }}笔
          </div>
          <div style="text-align: right">{{ curreny(total) }}</div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
        <div v-for="(item, index) in payItemDetail2" :key="'b' + index">
          <div v-for="(item2, index2) in item.list" :key="item.accNo + index2">
            <div class="report-line">
              <div>{{ item2.accNo }}</div>
              <div>{{ item2.guestName }}</div>
              <div>{{ item2.roomNo }}</div>
              <div>{{ item2.chnName }}</div>
              <div style="flex: 2">{{ item2.createTime }}</div>
              <div style="text-align: right">{{ curreny(item2.amount) }}</div>
              <div>{{ item2.hotelTime }}</div>
              <div>{{ item2.shift }}</div>
              <div>{{ item2.Operator }}</div>
              <div style="flex: 2">{{ item2.remark }}</div>
            </div>
          </div>
          <div class="report-line" style="font-weight: bold">
            <div></div>
            <div></div>
            <div></div>
            <div style="text-align: center">{{ item.chnName }}</div>
            <div style="text-align: center; flex: 2">
              小计{{ item.list.length }}笔
            </div>
            <div style="text-align: right">{{ curreny(item.total) }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div style="flex: 2"></div>
          </div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">结账款合计</div>
          <div style="text-align: center; flex: 2">
            小计{{ payItemList.jieZhang.length }}笔
          </div>
          <div style="text-align: right">{{ curreny(total2) }}</div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">合计</div>
          <div style="text-align: center; flex: 2">
            总计{{
              parseFloat(payItemList.yaJin.length) +
                parseFloat(payItemList.jieZhang.length)
            }}笔
          </div>
          <div style="text-align: right">
            {{ curreny(parseFloat(total2) + parseFloat(total)) }}
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
      </div>

      <div class="report" v-if="show2 && retrieveList.length > 0">
        <div style="margin-bottom: 5px;display:flex;align-items:center">
          收回收据明细
          <download-excel
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            :header="json_dataHead"
            :name="json_dataHead + '.xls'"
          >
            <div class="datadaochu" @click="daochu2">导出</div>
          </download-excel>
        </div>
        <div
          class="report-line"
          style="line-height: 30px; border-top: 1px solid black"
        >
          <div>账号</div>
          <div>姓名</div>
          <div>房号</div>
          <div>收款方式</div>
          <div style="flex: 2">发生时间</div>
          <div style="text-align: right">金额</div>
          <div>酒店时间</div>
          <div>班次</div>
          <div>操作员</div>
          <div style="flex: 2">备注</div>
        </div>

        <div v-for="(item, index) in retrieveDetail" :key="'a' + index">
          <div v-for="(item2, index2) in item.list" :key="item.accNo + index2">
            <div class="report-line">
              <div>{{ item2.accNo }}</div>
              <div>{{ item2.guestName }}</div>
              <div>{{ item2.roomNo }}</div>
              <div>{{ item2.chnName }}</div>
              <div style="flex: 2">{{ item2.createTime }}</div>
              <div style="text-align: right">{{ curreny(item2.amount) }}</div>
              <div>{{ item2.hotelTime }}</div>
              <div>{{ item2.shift }}</div>
              <div>{{ item2.Operator }}</div>
              <div style="flex: 2">{{ item2.remark }}</div>
            </div>
          </div>
          <div class="report-line" style="font-weight: bold">
            <div></div>
            <div></div>
            <div></div>
            <div style="text-align: center">{{ item.chnName }}</div>
            <div style="text-align: center; flex: 2">
              小计{{ item.list.length }}笔
            </div>
            <div style="text-align: right">{{ curreny(item.total) }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div style="flex: 2"></div>
          </div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">总合计:</div>
          <div style="text-align: center; flex: 2">
            合计{{ retrieveList.length }}笔
          </div>
          <div style="text-align: right">{{ curreny(total3) }}</div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
      </div>

      <div class="report" v-if="show3 && strikeItemList.length > 0">
        <div style="margin-bottom: 5px;display:flex;align-items:center">
          冲账、补负明细
          <download-excel
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            :header="json_dataHead"
            :name="json_dataHead + '.xls'"
          >
            <div class="datadaochu" @click="daochu4">导出</div>
          </download-excel>
        </div>
        <div
          class="report-line"
          style="line-height: 30px; border-top: 1px solid black"
        >
          <div>账号</div>
          <div>姓名</div>
          <div>房号</div>
          <div>收款方式</div>
          <div style="flex: 2">发生时间</div>
          <div style="text-align: right">金额</div>
          <div>酒店时间</div>
          <div>班次</div>
          <div>操作员</div>
          <div style="flex: 2">备注</div>
        </div>

        <div v-for="(item, index) in strikeItem" :key="'a' + index">
          <div v-for="(item2, index2) in item.list" :key="item.accNo + index2">
            <div class="report-line">
              <div>{{ item2.accNo }}</div>
              <div>{{ item2.guestName }}</div>
              <div>{{ item2.roomNo }}</div>
              <div>{{ item2.chnName }}</div>
              <div style="flex: 2">{{ item2.createTime }}</div>
              <div style="text-align: right">{{ curreny(item2.amount) }}</div>
              <div>{{ item2.hotelTime }}</div>
              <div>{{ item2.shift }}</div>
              <div>{{ item2.Operator }}</div>
              <div style="flex: 2">{{ item2.remark }}</div>
            </div>
          </div>
          <div class="report-line" style="font-weight: bold">
            <div></div>
            <div></div>
            <div></div>
            <div style="text-align: center">{{ item.chnName }}</div>
            <div style="text-align: center; flex: 2">
              小计{{ item.list.length }}笔
            </div>
            <div style="text-align: right">{{ curreny(item.total) }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div style="flex: 2"></div>
          </div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">总合计:</div>
          <div style="text-align: center; flex: 2">
            合计{{ strikeItemList.length }}笔
          </div>
          <div style="text-align: right">{{ curreny(total4) }}</div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
      </div>

      <div class="report" v-if="show4 && roomItemList.length > 0">
        <div style="margin-bottom: 5px;display:flex;align-items:center">
          补账明细
          <download-excel
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            :header="json_dataHead"
            :name="json_dataHead + '.xls'"
          >
            <div class="datadaochu" @click="daochu3">导出</div>
          </download-excel>
        </div>
        <div
          class="report-line"
          style="line-height: 30px; border-top: 1px solid black"
        >
          <div>账号</div>
          <div>姓名</div>
          <div>房号</div>
          <div>收款方式</div>
          <div style="flex: 2">发生时间</div>
          <div style="text-align: right">金额</div>
          <div>酒店时间</div>
          <div>班次</div>
          <div>操作员</div>
          <div style="flex: 2">备注</div>
        </div>

        <div v-for="(item, index) in roomItem" :key="'a' + index">
          <div v-for="(item2, index2) in item.list" :key="item.accNo + index2">
            <div class="report-line">
              <div>{{ item2.accNo }}</div>
              <div>{{ item2.guestName }}</div>
              <div>{{ item2.roomNo }}</div>
              <div>{{ item2.chnName }}</div>
              <div style="flex: 2">{{ item2.createTime }}</div>
              <div style="text-align: right">{{ curreny(item2.amount) }}</div>
              <div>{{ item2.hotelTime }}</div>
              <div>{{ item2.shift }}</div>
              <div>{{ item2.Operator }}</div>
              <div style="flex: 2">{{ item2.remark }}</div>
            </div>
          </div>
          <div class="report-line" style="font-weight: bold">
            <div></div>
            <div></div>
            <div></div>
            <div style="text-align: center">{{ item.chnName }}</div>
            <div style="text-align: center; flex: 2">
              小计{{ item.list.length }}笔
            </div>
            <div style="text-align: right">{{ curreny(item.total) }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div style="flex: 2"></div>
          </div>
        </div>
        <div class="report-line" style="font-weight: bold">
          <div></div>
          <div></div>
          <div></div>
          <div style="text-align: center">总合计:</div>
          <div style="text-align: center; flex: 2">
            合计{{ roomItemList.length }}笔
          </div>
          <div style="text-align: right">{{ curreny(total5) }}</div>
          <div></div>
          <div></div>
          <div></div>
          <div style="flex: 2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 本日预到的宾客表
      json_fields: {},
      json_data: [], //导出表格数据
      json_dataHead: "",
      list: [],
      obj: {},
      // 记录
      record: "",
      room: "",
      total: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      date: "",
      accountName: null,
      accountNameList: [],
      czymc: "全部",
      bcmc: "全部",
      DetailList: [],

      payItemList: [],
      payItemDetail: [],
      total: 0,
      payItemDetail2: [],
      total2: 0,
      retrieveList: [],
      retrieveDetail: [],
      total3: 0,
      strikeItemList: [],
      strikeItem: [],
      total4: 0,
      roomItemList: [],
      roomItem: [],
      total5: 0,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    banci() {
      return localStorage.getItem("bancidesc");
    },
    banciList() {
      return this.$store.state.tSysShift;
    },
    userList() {
      return this.$store.state.tSysUser;
    },
  },
  created() {
    let theDate = this.$store.state.hotelInfo.dhoteltime;
    let closingDate = new Date(
      new Date(theDate).getTime() - 24 * 60 * 60 * 1000
    );
    let lastDate = this.$moment(new Date(closingDate)).format("YYYY-MM-DD");
    // console.log(2555, this.$store.state.hotelInfo);
    this.$parent.closeshow();
    this.$parent.bbmc = "C17-2 收银员班缴款历史报表";
    this.$parent.startDates = this.$moment(new Date(lastDate)).format(
      "YYYY-MM-DD"
    );
    this.$parent.endDates = this.$moment(new Date(lastDate)).format(
      "YYYY-MM-DD"
    );
    this.$parent.showCzy = true;
    // this.$parent.canDaoChu2 = true;

    this.$parent.showBc = true;
    this.$parent.startTimeShows = true;
    this.$parent.endTimeShows = true;
    // this.$parent.banci == "";
    this.$parent.show1 = false;
    this.$parent.show2 = false;
    this.$parent.show3 = false;
    this.$parent.show4 = false;
    this.$parent.show11 = true;
    this.$parent.show22 = true;
    this.$parent.show33 = true;
    this.$parent.show44 = true;
    this.$parent.chaxunvib = true;
    this.doserach(true);
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach(boo) {
      this.getData();
      if (this.show1 || boo) {
        this.getPayItemDetail();
      }
      if (this.show2 || boo) {
        this.getRetrieveDetail();
      }
      if (this.show3 || boo) {
        this.getStrikeItem();
      }
      if (this.show4 || boo) {
        this.getRoomItem();
      }
    },
    getData() {
      this.accountName = null;
      this.$parent.czy == null;

      for (let key in this.obj) {
        this.obj[key] = 0;
      }
      var banci = this.$parent.banci;
      if (banci != null && banci != "") {
        for (var i = 0; i < this.banciList.length; i++) {
          if (banci == this.banciList[i].iid) {
            this.bcmc = this.banciList[i].cdesc;
            break;
          }
        }
      } else {
        this.bcmc = "全部";
      }
      if (this.$parent.czy != null && this.$parent.czy != "") {
        for (var i = 0; i < this.userList.length; i++) {
          if (this.$parent.czy == this.userList[i].cusercode) {
            this.czymc = this.userList[i].cname;
            break;
          }
        }
      } else {
        this.czymc = "全部";
      }

      let loadingInstance = this.$loading({ text: "正在查询..." });

      postRequest("/reportFrontCash/selectC1702", {
        startDate: this.$parent.startDates,
        endDate: this.$parent.endDates,
        shift: banci,
        operator: this.$parent.czy,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.$parent.datacount = res.data.payItem.length;
          let list = res.data.payItem;
          if (banci == null && this.$parent.czy == null) {
            this.list = list;
          } else {
            this.list.forEach((item) => {
              item.dingjin = 0;
              item.dingjinnum = 0;
              item.shouhuishouju = 0;
              item.shouhuishoujunum = 0;
              item.shoukuan = 0;
              item.shoukuannum = 0;
              item.tuikuan = 0;
              item.tuikuannum = 0;
              item.five = 0;
              item.three = 0;
              item.two = 0;
            });
            this.list.forEach((listItem, listIndex) => {
              list.forEach((item) => {
                if (item.txnitem == listItem.txnitem) {
                  this.list.splice(listIndex, 1, item);
                }
              });
            });
          }

          this.$store.state.preArrivalName = "C17-2 收银员班缴款历史报表";
          list.forEach((item) => {
            item.two = (
              parseFloat(item.shoukuan) + parseFloat(item.tuikuan)
            ).toFixed(2);
            item.num = item.shoukuannum + item.tuikuannum;
            item.three = (
              parseFloat(item.two) + parseFloat(item.dingjin)
            ).toFixed(2);
            item.five = (
              parseFloat(item.two) + parseFloat(item.shouhuishouju)
            ).toFixed(2);
          });
          this.$store.state.preArrivalList = list;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
          this.caculate();

        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    getPayItemDetail() {
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("reportFrontCash/selectReportPayItemDetail", {
        startDate: this.$parent.startDates,
        endDate: this.$parent.endDates,
        shift: this.$parent.banci,
        operator: this.$parent.czy,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          if (res.data && res.data.yaJin && res.data.yaJin.length > 0) {
            this.showList(
              JSON.parse(JSON.stringify(res.data.yaJin)),
              "payItemDetail",
              "total"
            );
          }
          if (res.data && res.data.jieZhang && res.data.jieZhang.length > 0) {
            this.showList(
              JSON.parse(JSON.stringify(res.data.jieZhang)),
              "payItemDetail2",
              "total2"
            );
          }

          this.payItemList = res.data;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    getRetrieveDetail() {
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("reportFrontCash/selectReportRetrieveDetail", {
        startDate: this.$parent.startDates,
        endDate: this.$parent.endDates,
        shift: this.$parent.banci,
        operator: this.$parent.czy,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          if (res.data.length > 0) {
            this.showList(
              JSON.parse(JSON.stringify(res.data)),
              "retrieveDetail",
              "total3"
            );
          }

          this.retrieveList = res.data;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    getStrikeItem() {
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("reportFrontCash/selectReportStrikeItem", {
        startDate: this.$parent.startDates,
        endDate: this.$parent.endDates,
        shift: this.$parent.banci,
        operator: this.$parent.czy,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          if (res.data.length > 0) {
            this.showList(
              JSON.parse(JSON.stringify(res.data)),
              "strikeItem",
              "total4"
            );
          }

          this.strikeItemList = res.data;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    getRoomItem() {
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("reportFrontCash/selectRoomItemByTxn", {
        startDate: this.$parent.startDates,
        endDate: this.$parent.endDates,
        shift: this.$parent.banci,
        operator: this.$parent.czy,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          if (res.data.length > 0) {
            this.showList(
              JSON.parse(JSON.stringify(res.data)),
              "roomItem",
              "total5"
            );
          }

          this.roomItemList = res.data;
          // this.$store.state.roomItem = this.roomItemList;
          // this.$store.state.roomItemName = "C17-2 收银员班缴款历史补账明细报表";
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    showList(list, str, str2) {
      let list2 = list.filter((item, index, arr) => {
        return (
          index ==
          arr.findIndex((innerItem, innerIndex) => {
            return item.txnItem == innerItem.txnItem;
          })
        );
      });
      let total = 0;
      list2.forEach((item) => {
        item.total = 0;
        list.forEach((item2) => {
          if (item.txnItem == item2.txnItem) {
            if (item.list) {
              item.list.push(item2);
              item.total += parseFloat(item2.amount);
              total += parseFloat(item2.amount);
            } else {
              item.list = [item2];
              item.total += parseFloat(item2.amount);
              total += parseFloat(item2.amount);
            }
          }
        });
      });

      this[str] = list2;
      this[str2] = total.toFixed(2);
    },
    daochu1() {
      let list = [];
      list.push({ accNo: "押金" });
      this.payItemDetail.forEach((item) => {
        item.list.forEach((item2) => {
          list.push(item2);
        });
      });
      list.push({ accNo: "结账" });
      this.payItemDetail2.forEach((item) => {
        item.list.forEach((item2) => {
          list.push(item2);
        });
      });
      // console.log(list);
      // return;
      this.json_data = list;
      this.json_dataHead = "押金、结账款明细";
      this.json_fields = {
        账号: "accNo",
        金额: "amount",
        收款方式: "chnName",
        发生时间: "createTime",
        姓名: "guestName",
        酒店时间: "hotelTime",
        备注: "remark",
        房号: "roomNo",
        班次: "shift",
        操作员: "Operator",
      };
    },
    daochu2() {
      let list = [];
      this.retrieveDetail.forEach((item) => {
        item.list.forEach((item2) => {
          list.push(item2);
        });
      });
      // console.log(list);
      // return;
      this.json_data = list;
      this.json_dataHead = "收回收据明细";
      this.json_fields = {
        账号: "accNo",
        金额: "amount",
        收款方式: "chnName",
        发生时间: "createTime",
        姓名: "guestName",
        酒店时间: "hotelTime",
        备注: "remark",
        房号: "roomNo",
        班次: "shift",
        操作员: "Operator",
      };
    },
    daochu3() {
      let list = [];
      this.roomItem.forEach((item) => {
        item.list.forEach((item2) => {
          list.push(item2);
        });
      });
      // console.log(list);
      this.json_data = list;
      this.json_dataHead = "补账明细";
      this.json_fields = {
        账号: "accNo",
        金额: "amount",
        收款方式: "chnName",
        发生时间: "createTime",
        姓名: "guestName",
        酒店时间: "hotelTime",
        备注: "remark",
        房号: "roomNo",
        班次: "shift",
        操作员: "Operator",
      };
    },
    daochu4() {
      let list = [];
      this.strikeItem.forEach((item) => {
        item.list.forEach((item2) => {
          list.push(item2);
        });
      });
      this.json_data = list;
      this.json_dataHead = "冲账、补负明细";
      this.json_fields = {
        账号: "accNo",
        金额: "amount",
        收款方式: "chnName",
        发生时间: "createTime",
        姓名: "guestName",
        酒店时间: "hotelTime",
        备注: "remark",
        房号: "roomNo",
        班次: "shift",
        操作员: "Operator",
      };
    },
    change(str) {
      this[str] = !this[str];
      if (this[str] == true) {
        this.doserach();
      }
    },
    caculate() {
      if (this.list.length > 0) {
        let list = this.list;
        let obj = JSON.parse(JSON.stringify(list[0]));
        delete obj.chnname;
        delete obj.txnitem;
        for (let key in obj) {
          //
          obj[key] = 0;
          for (let i = 0; i < list.length; i++) {
            for (let key2 in list[i]) {
              if (key == key2) {
                obj[key] += parseFloat(list[i][key2]);
              }
            }
          }
          //
          this.obj = obj;
        }
      }
    },
    curreny(data) {
      if (data != null && data != undefined) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    search() {
      this.listDetail = this.DetailList;
      let list = [];

      if (this.accountName == null) {
        this.listDetail = this.DetailList;
      } else {
        this.listDetail.forEach((item) => {
          if (item.chnName == this.accountName) {
            list.push(item);
          }
          this.listDetail = list;
        });
      }
    },
  },
};
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.formTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  line-height: 25px;
  margin-bottom: 10px;
  font-size: 14px;
}
.formTitle > li {
  width: 8%;
  text-align: center;
}
.PreArrivalItem {
  width: 8%;
  text-align: center;
}
.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 12em;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 12em;
  text-align: center;
  border: 1px solid #000;
}
.report {
  margin-bottom: 80px;
}

table th {
  font-weight: normal;
}
.trTitle {
  font-weight: bolder;
  border-bottom: 1px solid #000;
}
.trType {
  font-weight: bolder;
}
.trType .tdFlex > div {
  display: flex;
}
td .topDeshed {
  border-top: 2px dashed #000;
  flex: 1;
  transform: translateY(9px);
}

.reportMsg {
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
}

.reportMsg .reportLeft {
  border-bottom: 1px solid #000;
}

.reportMsg .reportLeft span {
  display: inline-block;
  margin-right: 10px;
}

.reprotRight {
  border-bottom: 1px solid #000;
}

.reprotRight span,
.reprotRight div {
  display: inline-block;
}

.reprotRight div {
  width: 150px;
}

.thTr {
  vertical-align: top;
  padding: 2px 0;
}
.thTr th {
  border: 1px solid #000;
}
.bdTop {
  border-top: 1px solid #000;
  height: 2px;
}
.bdBottom {
  border-bottom: 1px solid #000;
  height: 2px;
}

.table2Title {
  font-weight: 800;
  color: #0000ff;
  font-family: "Times New Roman", Times, serif;
  margin: 10px 0;
}

.table2 th,
.table2 td {
  border: 1px solid #000;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
.tableTitle {
  display: flex;
  align-items: center;
}
.accountName {
  margin-left: 20px;
}
.search {
  background: #1471fe !important;
  color: #fff !important;
  height: 30px;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
  width: 60px;
  text-align: center;
  margin-left: 50px;
}
.report {
  width: 100%;
  /* border-top: 1px solid black; */
  /* border-left: 1px solid black; */
  margin-bottom: 40px;
}
.report-line {
  display: flex;
  line-height: 25px;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  width: 100%;
}
.report-line > div {
  flex: 1;
  /* width: 130px; */
  border-right: 1px solid black;
  flex-shrink: 0;
  overflow: hidden;
  font-size: 14px;
  text-align: center;
}
.header-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.header-item > div img {
  width: 34px;
  height: 34px;
  margin-top: 3px;
}
.report-line > div:first-child {
  flex: 2 !important;
}
.datadaochu {
  margin-left: 10px;
}
</style>
